import React from 'react'

export const Trademark = () => (
  <div className="trademark">© {global.getCurrentYear()} THETICKETFAIRY All Rights Reserved</div>
)
